import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@/shared/ui/tabs.tsx'
// import ScheduledPostTab from "./components/scheduled/ScheduledPostTab";
// import PendingPostTab from "./components/PendingPostTab";
import { RotateCw, Rss, Signpost } from "lucide-react";
// import PublishedPostTab from "./published/PublishedPostTab";
import DiscardedEventTab from './discarded/DiscardedEventTab';
import PublishedEventTab from './published/PublishedEventTab';
import UnreviewedTab from './unreviewed/UnreviewedTab';

const PreviousView = () => {

  return (
    <div className="mt-[5vh] w-full h-[95vh] overflow-auto relative">
      <div className="flex justify-start items-center">
        <h1 className="font-header px-10 pt-5 pb-3 tracking-wide 2xl:pt-32 text-xl lg:text-5xl font-[500]">History</h1>
      </div>
      <div className="w-full flex justify-center items-center px-5 md:px-10">
        <Tabs className="w-full" defaultValue="posted">
          <TabsList className="grid grid-cols-3 max-w-[35rem] h-fit bg-transparent rounded-lg">
            <TabsTrigger value="posted" className="py-3 data-[state=active]:bg-white/30 rounded-lg font-montserrat data-[state=active]:border-b-2 data-[state=active]:border-b-black border-0 data-[state=active]:shadow-none flex items-center gap-1">
              <Signpost size={14} />
              <span>Published Content</span>
            </TabsTrigger>
            <TabsTrigger value="discarded" className="py-3 data-[state=active]:bg-white/30 rounded-lg font-montserrat data-[state=active]:border-b-2 data-[state=active]:border-b-black border-0 data-[state=active]:shadow-none flex items-center gap-1">
              <RotateCw size={12} />
              <span>Discarded Events</span>
            </TabsTrigger>
            <TabsTrigger value="unreviewed" className="py-3 rounded-lg font-montserrat data-[state=active]:bg-white/30 data-[state=active]:border-b-2 data-[state=active]:border-b-black border-0 data-[state=active]:shadow-none flex items-center gap-1">
              <Rss size={12} />
              <span>Unreviewed Events</span>
            </TabsTrigger>
          </TabsList>
          <TabsContent value="posted">
            <PublishedEventTab />
          </TabsContent>
          <TabsContent value="discarded">
            <DiscardedEventTab />
          </TabsContent>
          <TabsContent value="unreviewed">
            <UnreviewedTab />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  )
}

export default PreviousView
